module.exports = __webpack_public_path__ + "static/media/protection_paper_getty_tablet.6ac2421a.jpg";